<template>
    
    <card class="card" title="Agregar columna">
    <div>

        <formColumna/>

    </div>
    </card>


</template>


<script>

import formColumna from './_form';


export default{

    name:"crearColumna",
    components:{
        formColumna
    },
    data(){

        return{

        }

    }


}

</script>